/*
 * @Author: edvardchen
 * @Date:   2016-08-11 20:37:50
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-07-27 12:26:26
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import autobind from 'core-decorators/lib/autobind';

import { hasReachedBottom, track, listenToScroll, hasOffsetBottom } from '../../utility';
import { reportVideoPV } from '../../fetchers';
import { openImageReport } from '../../ducks/article';
import { findAllImages } from '../../utility/articleData';
import ReadAllMask from './ReadAllMask';
import Header from './Header';
// import Footer from './Footer';
import Content from './Content';

if (__CLIENT__) {
  require('./Article.scss');
}

class Article extends React.PureComponent {
  state = {
    collapsed: false,
    maxContentHeight: '', // 文章最大展示高度
    isChangeButtonStyle: false, // 是否改变文章按钮样式
  };
  imgExtInfo: Array<any> = [];
  allImages: Array<string> = [];
  componentDidMount() {
    // const { title, docId, contentFields, dispatch } = this.props;
    const { contentFields, apn } = this.props;
    const { all } = findAllImages(contentFields, apn === 'wifi');
    this.allImages = all;
    // if (title) {
    //   document.title = !this.props.share ? title : 'QQ浏览器';
    // }
    this.foldContent();
    this.watchReadFinish = listenToScroll(() => {
      if (!this.state.collapsed) {
        if (hasReachedBottom(this.contentNode.el)) {
          track({
            location: 'article',
            action: 'finish_reading',
            id: this.props.docId,
          });
          this.watchReadFinish.remove();
        }
      }
      // 判断阅读全文按钮位置
      if (this.state.collapsed && hasOffsetBottom(this.readAllMaskNode.el)) {
        this.setState({
          isChangeButtonStyle: true,
        });
      }
    });
  }

  componentWillUnmount() {
    this.watchReadFinish.remove();
  }
  @autobind
  contentClick({ target: el }) {
    if (el.tagName.toLowerCase() === 'img' && el.width >= 200) {
      this.onClickImage({ src: el.src, el });
    }
  }
  /**
   * 点击正文图片
   * @param  {String} options.src 图片地址
   * @param  {String} options.el  图片DOM
   */
  @autobind
  onClickImage({ src, el }) {
    track({
      location: 'article',
      action: 'open',
      object: 'ImgViewer',
      ch: this.props.ch,
    });
    const images = this.allImages || [];
    const offset = el.getBoundingClientRect();
    const openPicView = _.get(window, 'browser.coolread.openPicView');
    const { docId = '', subjectId = '' } = this.props || {};
    openImageReport({ docId, subjectId });
    openPicView &&
      openPicView({
        url: src,
        urls: images,
        index: images.indexOf(src),
        x: offset.left,
        y: offset.top,
        width: el.clientWidth,
        height: el.clientHeight,
        extInfo: this.imgExtInfo,
      });
  }

  @autobind
  onClickSource() {
    track({
      location: 'article',
      action: 'click',
      object: 'sourceLink',
      id: this.props.docId,
      ext: this.props.dataSrc,
    });
    browser.coolread.openExternalPage(this.props.url);
  }

  @autobind
  onPlayVideo({ vid }) {
    const { ch, docId } = this.props;
    reportVideoPV({
      ch,
      fromId: docId,
      vid,
    });
  }

  /**
   * 查看全文
   */
  @autobind
  readAll() {
    const reportLocation = this.props.share ? 'sharelp' : 'article';
    const reportObject = this.props.share ? 'sharelp_seemorearrow' : 'readAll';
    track({
      location: reportLocation,
      action: 'click',
      object: reportObject,
      id: this.props.docId,
      ch: this.props.ch,
    });
    this.setState({
      collapsed: false,
      maxContentHeight: '',
    });
  }

  /**
   * 正文折叠
   */
  foldContent() {
    const { collapseScreen } = this.props; // 展示多少屏内容
    const { el } = this.contentNode;
    if (!collapseScreen || !el) {
      return;
    }
    const threshold = collapseScreen * window.innerHeight;

    // 折叠部分必须超过一屏
    if (el.scrollHeight > threshold + window.innerHeight) {
      this.setState({
        collapsed: true,
        maxContentHeight: threshold,
      });
    }
  }

  @autobind
  exposureReadAll() {
    track({
      location: 'article',
      action: 'exposure',
      object: 'readAll',
      id: this.props.docId,
      ch: this.props.ch,
    });
  }

  render() {
    const {
      icon,
      title,
      avatar,
      time,
      from,
      url,
      copyright,
      sourceLinkText,
      fusionId,
      zimeitiId,
      dataSrc,
      mergePageInfo,
      isShareUser,
      sTitleLogo,
      isRumorTitle,
      contentFields,
      bUseHtml,
      ...rest
    } = this.props;
    const { maxContentHeight, collapsed } = this.state;
    const heightStyle = {
      maxHeight: maxContentHeight ? `${maxContentHeight}px` : 'initial',
    };
    const kalss = `mod-news-text ${isShareUser && 'is-share-user'}`;
    /* eslint-disable react/no-danger */
    return (
      <section className={kalss}>
        <Header
          {...{
            icon,
            title,
            from,
            time,
            dataSrc,
            avatar,
            id: fusionId,
            zimeitiId,
            share: !!this.props.share,
            mergePageInfo,
            sTitleLogo,
            isRumorTitle,
          }}
        />
        {typeof contentFields === 'string' ? (
          <div
            dangerouslySetInnerHTML={{ __html: contentFields }}
            id="new_content_version"
            ref={(node) => {
              this.contentNode = node;
            }}
            onClick={this.contentClick}
          />
        ) : (
          <Content
            {...rest}
            contentFields={contentFields}
            ref={(node) => {
              this.contentNode = node;
            }}
            onPlayVideo={this.onPlayVideo}
            onClickImage={this.onClickImage}
            onClickArticleImageBtn={this.props.onClickArticleImageBtn || null}
            style={heightStyle}
          />
        )}
        {collapsed && (
          <ReadAllMask
            ref={(node) => {
              this.readAllMaskNode = node;
            }}
            onReadAll={this.readAll}
            onExposure={this.exposureReadAll}
            share={!!this.props.share || false}
            onClickReadAll={this.props.onClickReadAll || null}
            isChangeButtonStyle={this.state.isChangeButtonStyle}
          />
        )}
      </section>
    );
  }
}

Article.defaultProps = {
  sourceLinkText: '阅读原文',
};

Article.propTypes = {
  ...Header.propTypes,
  // ...Footer.propTypes,
  ...Content.propTypes,
  collapseScreen: PropTypes.number,
};

export default Article;
